import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, KeepAlive as _KeepAlive, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-192f345b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row gx-5"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-auto mb-3" }
const _hoisted_5 = { class: "card position-relative" }
const _hoisted_6 = {
  key: 0,
  class: "position-absolute top-0 end-0 mt-2 me-2 text-black"
}
const _hoisted_7 = { class: "badge small bg-secondary text-primary p-2 ms-2 rounded-0" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "col-auto d-flex flex-column justify-content-between align-content-between mb-5" }
const _hoisted_11 = { class: "mt-2 mt-lg-0 mb-4 fs-3 fw-700" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-700" }, "CNK", -1))
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = { class: "fw-700" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "current-price fw-600 pe-2" }
const _hoisted_20 = ["data-bs-toggle", "data-bs-title"]
const _hoisted_21 = {
  key: 0,
  class: "mas info-icon-small"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "old-price text-decoration-line-through" }
const _hoisted_24 = {
  key: 1,
  class: "col-auto d-flex align-items-center flex-row"
}
const _hoisted_25 = ["data-bs-toggle", "data-bs-title"]
const _hoisted_26 = {
  key: 0,
  class: "mas info-icon-small"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "mb-2" }
const _hoisted_29 = { class: "fw-700" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "mb-2" }
const _hoisted_32 = { class: "fw-700" }
const _hoisted_33 = { class: "mb-2" }
const _hoisted_34 = { class: "fw-700" }
const _hoisted_35 = { class: "row gx-5" }
const _hoisted_36 = { class: "col-12" }
const _hoisted_37 = { class: "mb-3" }
const _hoisted_38 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Base selection tabs"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_CategoryWithParents = _resolveComponent("CategoryWithParents")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "container-fluid": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('product'),
          mb: 2,
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent,
          "back-route": _ctx.returnRoute
        }, null, 8, ["title", "onRefresh", "back-route"]),
        _createVNode(_component_AlertError2, {
          error: _ctx.productDetailUI.getError()
        }, null, 8, ["error"]),
        (_ctx.productDetailUI.isReady())
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (_ctx.product.product.discount && _ctx.product.product.discount.label)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("span", _hoisted_7, [
                              _createElementVNode("span", {
                                innerHTML: _ctx.product.product.discount?.label?.content ?? ''
                              }, null, 8, _hoisted_8)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("img", {
                        src: _ctx.product.main_image_url,
                        class: "card-img-top",
                        alt: _ctx.product.product.product_info.name,
                        style: {"width":"200px","height":"200px"}
                      }, null, 8, _hoisted_9)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.product.product.product_info.name), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("div", null, _toDisplayString(_ctx.product.product.product_info.cnk_code ?? _ctx.product.product.product_info.customer_cnk_code), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('priceInclVat')), 1),
                            _createElementVNode("div", null, [
                              ((_ctx.product.product.product_price?.discount_percentage ?? 0 > 0) || (_ctx.product.product.product_price?.discount_value_with_vat ?? 0 > 0))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(_ctx.priceClass),
                                        "data-bs-toggle": _ctx.tooltip ? 'tooltip' : null,
                                        "data-bs-title": _ctx.tooltip
                                      }, [
                                        _createTextVNode(" € "),
                                        (!_ctx.productPrice)
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_21, "info"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.productPrice), 1))
                                      ], 10, _hoisted_20)
                                    ]),
                                    _createElementVNode("div", _hoisted_23, " € " + _toDisplayString(_ctx.product.product.product_price.standard_price_with_vat), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(_ctx.priceClass),
                                      "data-bs-toggle": _ctx.tooltip ? 'tooltip' : null,
                                      "data-bs-title": _ctx.tooltip
                                    }, [
                                      _createTextVNode(" € "),
                                      (!_ctx.productPrice)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_26, "info"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.productPrice), 1))
                                    ], 10, _hoisted_25)
                                  ]))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('vatPercentage')), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.product.product.product_price.vat_percentage) + " %", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('usage')), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.product.product.product_info.usage?.description ?? ''), 1)
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('categories')), 1),
                            _createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.product.categories, (category) => {
                                return (_openBlock(), _createBlock(_component_CategoryWithParents, {
                                  key: category.code,
                                  category: category
                                }, null, 8, ["category"]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("nav", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-primary", {'active': _ctx.currentComponent === 'product-detail-prices-tab'}]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentComponent('product-detail-prices-tab')))
                }, _toDisplayString(_ctx.$t('prices')), 3),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-primary", {'active': _ctx.currentComponent === 'product-detail-categories-tab'}]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentComponent('product-detail-categories-tab')))
                }, _toDisplayString(_ctx.$t('categories')), 3),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-primary", {'active': _ctx.currentComponent === 'product-detail-photos-tab'}]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentComponent('product-detail-photos-tab')))
                }, _toDisplayString(_ctx.$t('photos')), 3),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-primary", {'active': _ctx.currentComponent === 'product-detail-pim-tab'}]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCurrentComponent('product-detail-pim-tab')))
                }, _toDisplayString(_ctx.$t('pim')), 3),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-primary", {'active': _ctx.currentComponent === 'product-detail-stock-tab'}]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setCurrentComponent('product-detail-stock-tab')))
                }, _toDisplayString(_ctx.$t('stock')), 3)
              ])
            ])
          ])
        ]),
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentDisplayedComponent), _mergeProps(_ctx.currentProperties, { onSavedSuccessfully: _ctx.handleSavedSuccessfully }), null, 16, ["onSavedSuccessfully"]))
        ], 1024))
      ]),
      _: 1
    }),
    _hoisted_39,
    _createVNode(_component_CatalogBuildStatus)
  ], 64))
}